import { Component, Inject } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { LxmMessage } from "src/app/_helpers";
import { ProductService } from "src/app/_services";

@Component({
  selector: "send-product-images-dialog",
  host: { class: "dialog" },
  templateUrl: "./send-product-images.dialog.html"
})
export class SendProductImagesDialog {
  public formGroup: FormGroup;

  public selectedProductIds = [];
  public actionLoading = {} as any;
  public contactOptions = [];

  constructor(
    public dialogRef: MatDialogRef<SendProductImagesDialog>,
    private _productService: ProductService,
    private _message: LxmMessage,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    const { productIds, contactOptions } = this.data || {};
    this.selectedProductIds = productIds;
    this.contactOptions = contactOptions;

    this.formGroup = new FormGroup({
      recipients: new FormControl(),
      comment: new FormControl(),
      isMasterOnly: new FormControl(false)
    });
  }

  // public get showTooManyProductsWarning() {
  //   return this.selectedProductIds.length > 20;
  // }

  public send() {
    const form = this.formGroup.value;

    const req: any = {
      recipients: form.recipients?.map((x) => x.email) ?? [],
      comment: form.comment,
      isMasterOnly: form.isMasterOnly,
      productIds: this.selectedProductIds
    };

    this._productService.sendImages(req).result(
      this.formGroup,
      (res) => {
        this.closeDialog(res);
        this._message.ok({ message: "cards.products.send_product_images_dialog.send_success" });
      },
      (e) => {
        console.error(e);
        this._message.error({ message: e.validationSummary ?? "global.generic_error" });
      },
      "send",
      this.actionLoading
    );
  }

  public addNewRecipient = (email) => {
    return new Promise((resolve) => {
      const newRecipient = {
        value: email,
        companyName: email,
        email: email,
        fullName: email
      };
      resolve(newRecipient);
    });
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public closeDialog(res = null) {
    this.dialogRef.close(res);
  }
}
